export const mockResponseSemantic = {
	isMock: true,
    "errorMessage": "",
    "status": "success",
    "offices": [
        "GB",
        "MY",
        "NZ",
        "AU",
        "SG",
        "US",
        "IN",
        "DE",
        "FR",
        "ES",
        "CH",
        "CA",
        "MX",
        "WO",
        "EM",
        "BR",
        "JP",
        "KR",
        "IT"
    ],
    "matches": [
        {
            "NiceClass": 30,
            "term": "sushi",
            "nbTotalOccurences": 18122,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 5983
                },
                {
                    "office": "MY",
                    "value": 544
                },
                {
                    "office": "NZ",
                    "value": 409
                },
                {
                    "office": "AU",
                    "value": 827
                },
                {
                    "office": "SG",
                    "value": 937
                },
                {
                    "office": "US",
                    "value": 913
                },
                {
                    "office": "IN",
                    "value": 95
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 1
                },
                {
                    "office": "CA",
                    "value": 91
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 3080
                },
                {
                    "office": "EM",
                    "value": 5238
                },
                {
                    "office": "BR",
                    "value": 4
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 1,
            "type": 2,
            "typeString": "nice",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi",
            "highlighted": "sushi"
        },
        {
            "NiceClass": 35,
            "term": "sushi",
            "nbTotalOccurences": 25,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 11
                },
                {
                    "office": "MY",
                    "value": 2
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 0
                },
                {
                    "office": "EM",
                    "value": 12
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 1,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi",
            "highlighted": "sushi"
        },
        {
            "NiceClass": 29,
            "term": "sashimi",
            "nbTotalOccurences": 1209,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 589
                },
                {
                    "office": "MY",
                    "value": 22
                },
                {
                    "office": "NZ",
                    "value": 14
                },
                {
                    "office": "AU",
                    "value": 54
                },
                {
                    "office": "SG",
                    "value": 50
                },
                {
                    "office": "US",
                    "value": 4
                },
                {
                    "office": "IN",
                    "value": 5
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 1
                },
                {
                    "office": "CA",
                    "value": 3
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 71
                },
                {
                    "office": "EM",
                    "value": 396
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.92811495,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sashimi",
            "highlighted": "sashimi"
        },
        {
            "NiceClass": 30,
            "term": "'sushi'",
            "nbTotalOccurences": 82,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 30
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 0
                },
                {
                    "office": "EM",
                    "value": 52
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8915177,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "'sushi'",
            "highlighted": "'sushi'"
        },
        {
            "NiceClass": 30,
            "term": "temaki sushi",
            "nbTotalOccurences": 24,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 8
                },
                {
                    "office": "NZ",
                    "value": 12
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 1
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.88657457,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "temaki sushi",
            "highlighted": "temaki sushi"
        },
        {
            "NiceClass": 30,
            "term": "sushi, tabbouleh",
            "nbTotalOccurences": 43,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 4
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 1
                },
                {
                    "office": "AU",
                    "value": 3
                },
                {
                    "office": "SG",
                    "value": 2
                },
                {
                    "office": "US",
                    "value": 2
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 30
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 1
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.88508695,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi, tabbouleh",
            "highlighted": "sushi, tabbouleh"
        },
        {
            "NiceClass": 30,
            "term": "maki sushi",
            "nbTotalOccurences": 24,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 8
                },
                {
                    "office": "NZ",
                    "value": 14
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.877669,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "maki sushi",
            "highlighted": "maki sushi"
        },
        {
            "NiceClass": 30,
            "term": "vegetarian sushi",
            "nbTotalOccurences": 30,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 6
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 2
                },
                {
                    "office": "AU",
                    "value": 5
                },
                {
                    "office": "SG",
                    "value": 1
                },
                {
                    "office": "US",
                    "value": 4
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 7
                },
                {
                    "office": "EM",
                    "value": 5
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8741254,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "vegetarian sushi",
            "highlighted": "vegetarian sushi"
        },
        {
            "NiceClass": 30,
            "term": "spring rolls, sushi",
            "nbTotalOccurences": 43,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 19
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 3
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 1
                },
                {
                    "office": "EM",
                    "value": 19
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8633963,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "spring rolls, sushi",
            "highlighted": "spring rolls, sushi"
        },
        {
            "NiceClass": 30,
            "term": "norimaki sushi",
            "nbTotalOccurences": 28,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 6
                },
                {
                    "office": "NZ",
                    "value": 18
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8618069,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "norimaki sushi",
            "highlighted": "norimaki sushi"
        },
        {
            "NiceClass": 30,
            "term": "futomaki sushi",
            "nbTotalOccurences": 22,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 8
                },
                {
                    "office": "NZ",
                    "value": 12
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.86172974,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "futomaki sushi",
            "highlighted": "futomaki sushi"
        },
        {
            "NiceClass": 29,
            "term": "seafood",
            "nbTotalOccurences": 2403,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 1166
                },
                {
                    "office": "MY",
                    "value": 33
                },
                {
                    "office": "NZ",
                    "value": 159
                },
                {
                    "office": "AU",
                    "value": 197
                },
                {
                    "office": "SG",
                    "value": 52
                },
                {
                    "office": "US",
                    "value": 104
                },
                {
                    "office": "IN",
                    "value": 18
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 126
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 120
                },
                {
                    "office": "EM",
                    "value": 428
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.861533,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "seafood",
            "highlighted": "seafood"
        },
        {
            "NiceClass": 30,
            "term": "uramaki sushi",
            "nbTotalOccurences": 22,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 7
                },
                {
                    "office": "NZ",
                    "value": 12
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8571013,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "uramaki sushi",
            "highlighted": "uramaki sushi"
        },
        {
            "NiceClass": 30,
            "term": "wasabi",
            "nbTotalOccurences": 217,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 106
                },
                {
                    "office": "MY",
                    "value": 2
                },
                {
                    "office": "NZ",
                    "value": 6
                },
                {
                    "office": "AU",
                    "value": 16
                },
                {
                    "office": "SG",
                    "value": 4
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 4
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 29
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 12
                },
                {
                    "office": "EM",
                    "value": 37
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8530376,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "wasabi",
            "highlighted": "wasabi"
        },
        {
            "NiceClass": 43,
            "term": "sushi-bars",
            "nbTotalOccurences": 43,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 12
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 2
                },
                {
                    "office": "SG",
                    "value": 23
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 6
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8511863,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi-bars",
            "highlighted": "sushi-bars"
        },
        {
            "NiceClass": 43,
            "term": "sushi bars",
            "nbTotalOccurences": 103,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 31
                },
                {
                    "office": "MY",
                    "value": 11
                },
                {
                    "office": "NZ",
                    "value": 6
                },
                {
                    "office": "AU",
                    "value": 8
                },
                {
                    "office": "SG",
                    "value": 22
                },
                {
                    "office": "US",
                    "value": 2
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 1
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 6
                },
                {
                    "office": "EM",
                    "value": 16
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.85023963,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi bars",
            "highlighted": "sushi bars"
        },
        {
            "NiceClass": 30,
            "term": "hosomaki sushi",
            "nbTotalOccurences": 20,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 6
                },
                {
                    "office": "NZ",
                    "value": 12
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.84966844,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "hosomaki sushi",
            "highlighted": "hosomaki sushi"
        },
        {
            "NiceClass": 29,
            "term": "ceviche",
            "nbTotalOccurences": 48,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 3
                },
                {
                    "office": "MY",
                    "value": 4
                },
                {
                    "office": "NZ",
                    "value": 3
                },
                {
                    "office": "AU",
                    "value": 12
                },
                {
                    "office": "SG",
                    "value": 1
                },
                {
                    "office": "US",
                    "value": 16
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 1
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 7
                },
                {
                    "office": "EM",
                    "value": 1
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8486201,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "ceviche",
            "highlighted": "ceviche"
        },
        {
            "NiceClass": 30,
            "term": "nigiri sushi",
            "nbTotalOccurences": 30,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 7
                },
                {
                    "office": "NZ",
                    "value": 19
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.84823126,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "nigiri sushi",
            "highlighted": "nigiri sushi"
        },
        {
            "NiceClass": 30,
            "term": "pizza",
            "nbTotalOccurences": 14426,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 5592
                },
                {
                    "office": "MY",
                    "value": 339
                },
                {
                    "office": "NZ",
                    "value": 409
                },
                {
                    "office": "AU",
                    "value": 1091
                },
                {
                    "office": "SG",
                    "value": 447
                },
                {
                    "office": "US",
                    "value": 1384
                },
                {
                    "office": "IN",
                    "value": 116
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 3
                },
                {
                    "office": "CA",
                    "value": 155
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 854
                },
                {
                    "office": "EM",
                    "value": 4034
                },
                {
                    "office": "BR",
                    "value": 2
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.84730464,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "pizza",
            "highlighted": "pizza"
        },
        {
            "NiceClass": 29,
            "term": "seafoods",
            "nbTotalOccurences": 105,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 72
                },
                {
                    "office": "MY",
                    "value": 2
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 6
                },
                {
                    "office": "SG",
                    "value": 4
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 10
                },
                {
                    "office": "EM",
                    "value": 11
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8456704,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "seafoods",
            "highlighted": "seafoods"
        },
        {
            "NiceClass": 29,
            "term": "caviar",
            "nbTotalOccurences": 10481,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 3737
                },
                {
                    "office": "MY",
                    "value": 164
                },
                {
                    "office": "NZ",
                    "value": 170
                },
                {
                    "office": "AU",
                    "value": 325
                },
                {
                    "office": "SG",
                    "value": 292
                },
                {
                    "office": "US",
                    "value": 502
                },
                {
                    "office": "IN",
                    "value": 29
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 48
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 1783
                },
                {
                    "office": "EM",
                    "value": 3426
                },
                {
                    "office": "BR",
                    "value": 5
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.84475267,
            "type": 2,
            "typeString": "nice",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "caviar",
            "highlighted": "caviar"
        },
        {
            "NiceClass": 35,
            "term": "caviar",
            "nbTotalOccurences": 31,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 12
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 1
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 5
                },
                {
                    "office": "EM",
                    "value": 13
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.84475267,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "caviar",
            "highlighted": "caviar"
        },
        {
            "NiceClass": 30,
            "term": "onigiri",
            "nbTotalOccurences": 989,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 339
                },
                {
                    "office": "MY",
                    "value": 49
                },
                {
                    "office": "NZ",
                    "value": 13
                },
                {
                    "office": "AU",
                    "value": 52
                },
                {
                    "office": "SG",
                    "value": 66
                },
                {
                    "office": "US",
                    "value": 47
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 3
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 366
                },
                {
                    "office": "EM",
                    "value": 53
                },
                {
                    "office": "BR",
                    "value": 1
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8432592,
            "type": 2,
            "typeString": "nice",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "onigiri",
            "highlighted": "onigiri"
        },
        {
            "NiceClass": 30,
            "term": "maki",
            "nbTotalOccurences": 123,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 36
                },
                {
                    "office": "MY",
                    "value": 5
                },
                {
                    "office": "NZ",
                    "value": 4
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 1
                },
                {
                    "office": "US",
                    "value": 2
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 40
                },
                {
                    "office": "EM",
                    "value": 34
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8419337,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "maki",
            "highlighted": "maki"
        },
        {
            "NiceClass": 30,
            "term": "sushi rice",
            "nbTotalOccurences": 31,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 10
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 6
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 4
                },
                {
                    "office": "EM",
                    "value": 10
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8407243,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sushi rice",
            "highlighted": "sushi rice"
        },
        {
            "NiceClass": 30,
            "term": "wasabi sauce",
            "nbTotalOccurences": 144,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 42
                },
                {
                    "office": "MY",
                    "value": 27
                },
                {
                    "office": "NZ",
                    "value": 16
                },
                {
                    "office": "AU",
                    "value": 3
                },
                {
                    "office": "SG",
                    "value": 6
                },
                {
                    "office": "US",
                    "value": 2
                },
                {
                    "office": "IN",
                    "value": 7
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 25
                },
                {
                    "office": "EM",
                    "value": 16
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8404472,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "wasabi sauce",
            "highlighted": "wasabi sauce"
        },
        {
            "NiceClass": 29,
            "term": "tempura seafood",
            "nbTotalOccurences": 192,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 6
                },
                {
                    "office": "MY",
                    "value": 44
                },
                {
                    "office": "NZ",
                    "value": 56
                },
                {
                    "office": "AU",
                    "value": 12
                },
                {
                    "office": "SG",
                    "value": 19
                },
                {
                    "office": "US",
                    "value": 37
                },
                {
                    "office": "IN",
                    "value": 1
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 1
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 13
                },
                {
                    "office": "EM",
                    "value": 3
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8392293,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "tempura seafood",
            "highlighted": "tempura seafood"
        },
        {
            "NiceClass": 29,
            "term": "miso soup",
            "nbTotalOccurences": 1243,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 625
                },
                {
                    "office": "MY",
                    "value": 10
                },
                {
                    "office": "NZ",
                    "value": 13
                },
                {
                    "office": "AU",
                    "value": 99
                },
                {
                    "office": "SG",
                    "value": 32
                },
                {
                    "office": "US",
                    "value": 22
                },
                {
                    "office": "IN",
                    "value": 5
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 51
                },
                {
                    "office": "EM",
                    "value": 386
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8376255,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "miso soup",
            "highlighted": "miso soup"
        },
        {
            "NiceClass": 29,
            "term": "sea food",
            "nbTotalOccurences": 193,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 177
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 1
                },
                {
                    "office": "EM",
                    "value": 15
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.83631736,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sea food",
            "highlighted": "sea food"
        },
        {
            "NiceClass": 30,
            "term": "seaweed rolls",
            "nbTotalOccurences": 27,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 9
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 2
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 0
                },
                {
                    "office": "EM",
                    "value": 16
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8353842,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "seaweed rolls",
            "highlighted": "seaweed rolls"
        },
        {
            "NiceClass": 30,
            "term": "eggrolls",
            "nbTotalOccurences": 32,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 8
                },
                {
                    "office": "MY",
                    "value": 5
                },
                {
                    "office": "NZ",
                    "value": 5
                },
                {
                    "office": "AU",
                    "value": 2
                },
                {
                    "office": "SG",
                    "value": 3
                },
                {
                    "office": "US",
                    "value": 2
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 1
                },
                {
                    "office": "EM",
                    "value": 6
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.83522326,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "eggrolls",
            "highlighted": "eggrolls"
        },
        {
            "NiceClass": 29,
            "term": "kimchi",
            "nbTotalOccurences": 1235,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 308
                },
                {
                    "office": "MY",
                    "value": 52
                },
                {
                    "office": "NZ",
                    "value": 42
                },
                {
                    "office": "AU",
                    "value": 84
                },
                {
                    "office": "SG",
                    "value": 73
                },
                {
                    "office": "US",
                    "value": 201
                },
                {
                    "office": "IN",
                    "value": 8
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 8
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 395
                },
                {
                    "office": "EM",
                    "value": 64
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8342078,
            "type": 2,
            "typeString": "nice",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "kimchi",
            "highlighted": "kimchi"
        },
        {
            "NiceClass": 29,
            "term": "tempura",
            "nbTotalOccurences": 34,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 6
                },
                {
                    "office": "MY",
                    "value": 11
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 10
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 0
                },
                {
                    "office": "EM",
                    "value": 6
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.832476,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "tempura",
            "highlighted": "tempura"
        },
        {
            "NiceClass": 29,
            "term": "salad",
            "nbTotalOccurences": 112,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 61
                },
                {
                    "office": "MY",
                    "value": 4
                },
                {
                    "office": "NZ",
                    "value": 1
                },
                {
                    "office": "AU",
                    "value": 3
                },
                {
                    "office": "SG",
                    "value": 7
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 2
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 9
                },
                {
                    "office": "EM",
                    "value": 25
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.83246285,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "salad",
            "highlighted": "salad"
        },
        {
            "NiceClass": 29,
            "term": "shrimp",
            "nbTotalOccurences": 112,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 47
                },
                {
                    "office": "MY",
                    "value": 2
                },
                {
                    "office": "NZ",
                    "value": 1
                },
                {
                    "office": "AU",
                    "value": 10
                },
                {
                    "office": "SG",
                    "value": 5
                },
                {
                    "office": "US",
                    "value": 12
                },
                {
                    "office": "IN",
                    "value": 2
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 1
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 12
                },
                {
                    "office": "EM",
                    "value": 20
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8322746,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "shrimp",
            "highlighted": "shrimp"
        },
        {
            "NiceClass": 30,
            "term": "rice",
            "nbTotalOccurences": 74396,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 24295
                },
                {
                    "office": "MY",
                    "value": 2866
                },
                {
                    "office": "NZ",
                    "value": 1963
                },
                {
                    "office": "AU",
                    "value": 4494
                },
                {
                    "office": "SG",
                    "value": 3563
                },
                {
                    "office": "US",
                    "value": 4178
                },
                {
                    "office": "IN",
                    "value": 2316
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 384
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 9183
                },
                {
                    "office": "EM",
                    "value": 21145
                },
                {
                    "office": "BR",
                    "value": 9
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82955694,
            "type": 2,
            "typeString": "nice",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "rice",
            "highlighted": "rice"
        },
        {
            "NiceClass": 35,
            "term": "rice",
            "nbTotalOccurences": 278,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 84
                },
                {
                    "office": "MY",
                    "value": 1
                },
                {
                    "office": "NZ",
                    "value": 7
                },
                {
                    "office": "AU",
                    "value": 2
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 95
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 8
                },
                {
                    "office": "EM",
                    "value": 80
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82955694,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "rice",
            "highlighted": "rice"
        },
        {
            "NiceClass": 31,
            "term": "rice",
            "nbTotalOccurences": 36,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 12
                },
                {
                    "office": "MY",
                    "value": 1
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 7
                },
                {
                    "office": "SG",
                    "value": 1
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 6
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 7
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82955694,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "rice",
            "highlighted": "rice"
        },
        {
            "NiceClass": 29,
            "term": "soup",
            "nbTotalOccurences": 1851,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 957
                },
                {
                    "office": "MY",
                    "value": 99
                },
                {
                    "office": "NZ",
                    "value": 64
                },
                {
                    "office": "AU",
                    "value": 130
                },
                {
                    "office": "SG",
                    "value": 87
                },
                {
                    "office": "US",
                    "value": 114
                },
                {
                    "office": "IN",
                    "value": 18
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 71
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 125
                },
                {
                    "office": "EM",
                    "value": 186
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8294901,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "soup",
            "highlighted": "soup"
        },
        {
            "NiceClass": 29,
            "term": "steak",
            "nbTotalOccurences": 125,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 45
                },
                {
                    "office": "MY",
                    "value": 11
                },
                {
                    "office": "NZ",
                    "value": 12
                },
                {
                    "office": "AU",
                    "value": 30
                },
                {
                    "office": "SG",
                    "value": 1
                },
                {
                    "office": "US",
                    "value": 2
                },
                {
                    "office": "IN",
                    "value": 2
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 1
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 8
                },
                {
                    "office": "EM",
                    "value": 13
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82891506,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "steak",
            "highlighted": "steak"
        },
        {
            "NiceClass": 30,
            "term": "miso",
            "nbTotalOccurences": 1292,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 400
                },
                {
                    "office": "MY",
                    "value": 73
                },
                {
                    "office": "NZ",
                    "value": 38
                },
                {
                    "office": "AU",
                    "value": 71
                },
                {
                    "office": "SG",
                    "value": 118
                },
                {
                    "office": "US",
                    "value": 79
                },
                {
                    "office": "IN",
                    "value": 2
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 3
                },
                {
                    "office": "CA",
                    "value": 6
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 422
                },
                {
                    "office": "EM",
                    "value": 79
                },
                {
                    "office": "BR",
                    "value": 1
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82784945,
            "type": 2,
            "typeString": "nice",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "miso",
            "highlighted": "miso"
        },
        {
            "NiceClass": 29,
            "term": "lobster",
            "nbTotalOccurences": 140,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 40
                },
                {
                    "office": "MY",
                    "value": 3
                },
                {
                    "office": "NZ",
                    "value": 4
                },
                {
                    "office": "AU",
                    "value": 21
                },
                {
                    "office": "SG",
                    "value": 8
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 43
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 11
                },
                {
                    "office": "EM",
                    "value": 9
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82736135,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "lobster",
            "highlighted": "lobster"
        },
        {
            "NiceClass": 29,
            "term": "oysters",
            "nbTotalOccurences": 129,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 48
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 1
                },
                {
                    "office": "AU",
                    "value": 4
                },
                {
                    "office": "SG",
                    "value": 1
                },
                {
                    "office": "US",
                    "value": 11
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 37
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 5
                },
                {
                    "office": "EM",
                    "value": 22
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82732254,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "oysters",
            "highlighted": "oysters"
        },
        {
            "NiceClass": 30,
            "term": "noodles",
            "nbTotalOccurences": 28277,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 7252
                },
                {
                    "office": "MY",
                    "value": 1963
                },
                {
                    "office": "NZ",
                    "value": 1276
                },
                {
                    "office": "AU",
                    "value": 2535
                },
                {
                    "office": "SG",
                    "value": 2474
                },
                {
                    "office": "US",
                    "value": 1892
                },
                {
                    "office": "IN",
                    "value": 538
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 303
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 3844
                },
                {
                    "office": "EM",
                    "value": 6191
                },
                {
                    "office": "BR",
                    "value": 9
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8273215,
            "type": 2,
            "typeString": "nice",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "noodles",
            "highlighted": "noodles"
        },
        {
            "NiceClass": 35,
            "term": "noodles",
            "nbTotalOccurences": 74,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 23
                },
                {
                    "office": "MY",
                    "value": 2
                },
                {
                    "office": "NZ",
                    "value": 2
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 22
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 5
                },
                {
                    "office": "EM",
                    "value": 19
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8273215,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "noodles",
            "highlighted": "noodles"
        },
        {
            "NiceClass": 29,
            "term": "yu sheng (raw fish salad)",
            "nbTotalOccurences": 51,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 9
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 1
                },
                {
                    "office": "SG",
                    "value": 40
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 1
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82730466,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "yu sheng (raw fish salad)",
            "highlighted": "yu sheng (raw fish salad)"
        },
        {
            "NiceClass": 29,
            "term": "tofu",
            "nbTotalOccurences": 17917,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 5414
                },
                {
                    "office": "MY",
                    "value": 730
                },
                {
                    "office": "NZ",
                    "value": 710
                },
                {
                    "office": "AU",
                    "value": 1188
                },
                {
                    "office": "SG",
                    "value": 1074
                },
                {
                    "office": "US",
                    "value": 929
                },
                {
                    "office": "IN",
                    "value": 89
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 7
                },
                {
                    "office": "CA",
                    "value": 109
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2815
                },
                {
                    "office": "EM",
                    "value": 4846
                },
                {
                    "office": "BR",
                    "value": 6
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82713044,
            "type": 2,
            "typeString": "nice",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "tofu",
            "highlighted": "tofu"
        },
        {
            "NiceClass": 35,
            "term": "tofu",
            "nbTotalOccurences": 29,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 15
                },
                {
                    "office": "MY",
                    "value": 1
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 1
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 1
                },
                {
                    "office": "EM",
                    "value": 11
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82713044,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "tofu",
            "highlighted": "tofu"
        },
        {
            "NiceClass": 29,
            "term": "scallops",
            "nbTotalOccurences": 36,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 16
                },
                {
                    "office": "MY",
                    "value": 3
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 5
                },
                {
                    "office": "SG",
                    "value": 1
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 3
                },
                {
                    "office": "EM",
                    "value": 8
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8269004,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "scallops",
            "highlighted": "scallops"
        },
        {
            "NiceClass": 30,
            "term": "kimbap",
            "nbTotalOccurences": 202,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 13
                },
                {
                    "office": "MY",
                    "value": 7
                },
                {
                    "office": "NZ",
                    "value": 1
                },
                {
                    "office": "AU",
                    "value": 5
                },
                {
                    "office": "SG",
                    "value": 13
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 117
                },
                {
                    "office": "EM",
                    "value": 46
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82646805,
            "type": 2,
            "typeString": "nice",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "kimbap",
            "highlighted": "kimbap"
        },
        {
            "NiceClass": 29,
            "term": "sukiyaki",
            "nbTotalOccurences": 43,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 0
                },
                {
                    "office": "MY",
                    "value": 7
                },
                {
                    "office": "NZ",
                    "value": 1
                },
                {
                    "office": "AU",
                    "value": 15
                },
                {
                    "office": "SG",
                    "value": 20
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 0
                },
                {
                    "office": "EM",
                    "value": 0
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8253357,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sukiyaki",
            "highlighted": "sukiyaki"
        },
        {
            "NiceClass": 29,
            "term": "sea foods",
            "nbTotalOccurences": 372,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 192
                },
                {
                    "office": "MY",
                    "value": 4
                },
                {
                    "office": "NZ",
                    "value": 3
                },
                {
                    "office": "AU",
                    "value": 7
                },
                {
                    "office": "SG",
                    "value": 2
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 13
                },
                {
                    "office": "EM",
                    "value": 151
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8253129,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sea foods",
            "highlighted": "sea foods"
        },
        {
            "NiceClass": 30,
            "term": "dim sum",
            "nbTotalOccurences": 108,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 37
                },
                {
                    "office": "MY",
                    "value": 7
                },
                {
                    "office": "NZ",
                    "value": 14
                },
                {
                    "office": "AU",
                    "value": 31
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 4
                },
                {
                    "office": "EM",
                    "value": 15
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82478017,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "dim sum",
            "highlighted": "dim sum"
        },
        {
            "NiceClass": 29,
            "term": "fish, seafood",
            "nbTotalOccurences": 25,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 9
                },
                {
                    "office": "MY",
                    "value": 1
                },
                {
                    "office": "NZ",
                    "value": 1
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 6
                },
                {
                    "office": "EM",
                    "value": 8
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82426894,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "fish, seafood",
            "highlighted": "fish, seafood"
        },
        {
            "NiceClass": 30,
            "term": "sandwich",
            "nbTotalOccurences": 87,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 13
                },
                {
                    "office": "MY",
                    "value": 18
                },
                {
                    "office": "NZ",
                    "value": 2
                },
                {
                    "office": "AU",
                    "value": 4
                },
                {
                    "office": "SG",
                    "value": 17
                },
                {
                    "office": "US",
                    "value": 6
                },
                {
                    "office": "IN",
                    "value": 11
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 9
                },
                {
                    "office": "EM",
                    "value": 7
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82398593,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "sandwich",
            "highlighted": "sandwich"
        },
        {
            "NiceClass": 30,
            "term": "onigiri (rice balls)",
            "nbTotalOccurences": 2382,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 1286
                },
                {
                    "office": "MY",
                    "value": 53
                },
                {
                    "office": "NZ",
                    "value": 41
                },
                {
                    "office": "AU",
                    "value": 81
                },
                {
                    "office": "SG",
                    "value": 140
                },
                {
                    "office": "US",
                    "value": 39
                },
                {
                    "office": "IN",
                    "value": 19
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 8
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 353
                },
                {
                    "office": "EM",
                    "value": 358
                },
                {
                    "office": "BR",
                    "value": 4
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82331026,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "onigiri (rice balls)",
            "highlighted": "onigiri (rice balls)"
        },
        {
            "NiceClass": 30,
            "term": "shrimp rolls",
            "nbTotalOccurences": 38,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 3
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 2
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 2
                },
                {
                    "office": "US",
                    "value": 3
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 24
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 1
                },
                {
                    "office": "EM",
                    "value": 3
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8226654,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "shrimp rolls",
            "highlighted": "shrimp rolls"
        },
        {
            "NiceClass": 29,
            "term": "surimi",
            "nbTotalOccurences": 738,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 387
                },
                {
                    "office": "MY",
                    "value": 19
                },
                {
                    "office": "NZ",
                    "value": 7
                },
                {
                    "office": "AU",
                    "value": 3
                },
                {
                    "office": "SG",
                    "value": 18
                },
                {
                    "office": "US",
                    "value": 3
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 1
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 24
                },
                {
                    "office": "EM",
                    "value": 276
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8226488,
            "type": 1,
            "typeString": "mgs",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "surimi",
            "highlighted": "surimi"
        },
        {
            "NiceClass": 29,
            "term": "seaweed snacks",
            "nbTotalOccurences": 32,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 20
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 2
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2
                },
                {
                    "office": "EM",
                    "value": 7
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82238954,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "seaweed snacks",
            "highlighted": "seaweed snacks"
        },
        {
            "NiceClass": 29,
            "term": "calamari",
            "nbTotalOccurences": 30,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 16
                },
                {
                    "office": "MY",
                    "value": 1
                },
                {
                    "office": "NZ",
                    "value": 1
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 2
                },
                {
                    "office": "US",
                    "value": 1
                },
                {
                    "office": "IN",
                    "value": 0
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 6
                },
                {
                    "office": "EM",
                    "value": 3
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8211599,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "calamari",
            "highlighted": "calamari"
        },
        {
            "NiceClass": 30,
            "term": "spring rolls",
            "nbTotalOccurences": 13518,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 4836
                },
                {
                    "office": "MY",
                    "value": 422
                },
                {
                    "office": "NZ",
                    "value": 235
                },
                {
                    "office": "AU",
                    "value": 511
                },
                {
                    "office": "SG",
                    "value": 542
                },
                {
                    "office": "US",
                    "value": 474
                },
                {
                    "office": "IN",
                    "value": 108
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 73
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 2064
                },
                {
                    "office": "EM",
                    "value": 4249
                },
                {
                    "office": "BR",
                    "value": 4
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82115287,
            "type": 2,
            "typeString": "nice",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "spring rolls",
            "highlighted": "spring rolls"
        },
        {
            "NiceClass": 35,
            "term": "spring rolls",
            "nbTotalOccurences": 25,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 10
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 1
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 4
                },
                {
                    "office": "EM",
                    "value": 10
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.82115287,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "spring rolls",
            "highlighted": "spring rolls"
        },
        {
            "NiceClass": 30,
            "term": "tacos",
            "nbTotalOccurences": 12626,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 4646
                },
                {
                    "office": "MY",
                    "value": 224
                },
                {
                    "office": "NZ",
                    "value": 176
                },
                {
                    "office": "AU",
                    "value": 404
                },
                {
                    "office": "SG",
                    "value": 305
                },
                {
                    "office": "US",
                    "value": 483
                },
                {
                    "office": "IN",
                    "value": 100
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 68
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 1936
                },
                {
                    "office": "EM",
                    "value": 4275
                },
                {
                    "office": "BR",
                    "value": 9
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8208235,
            "type": 2,
            "typeString": "nice",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "tacos",
            "highlighted": "tacos"
        },
        {
            "NiceClass": 35,
            "term": "tacos",
            "nbTotalOccurences": 29,
            "nbOccurences": [
                {
                    "office": "GB",
                    "value": 11
                },
                {
                    "office": "MY",
                    "value": 0
                },
                {
                    "office": "NZ",
                    "value": 0
                },
                {
                    "office": "AU",
                    "value": 0
                },
                {
                    "office": "SG",
                    "value": 0
                },
                {
                    "office": "US",
                    "value": 0
                },
                {
                    "office": "IN",
                    "value": 2
                },
                {
                    "office": "DE",
                    "value": 0
                },
                {
                    "office": "FR",
                    "value": 0
                },
                {
                    "office": "ES",
                    "value": 0
                },
                {
                    "office": "CH",
                    "value": 0
                },
                {
                    "office": "CA",
                    "value": 0
                },
                {
                    "office": "MX",
                    "value": 0
                },
                {
                    "office": "WO",
                    "value": 4
                },
                {
                    "office": "EM",
                    "value": 12
                },
                {
                    "office": "BR",
                    "value": 0
                },
                {
                    "office": "JP",
                    "value": 0
                },
                {
                    "office": "KR",
                    "value": 0
                },
                {
                    "office": "IT",
                    "value": 0
                }
            ],
            "nbOccurencesTimeline": null,
            "similarityScore": 0.8208235,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": false,
            "term_for_link": "tacos",
            "highlighted": "tacos"
        }
    ],
    "startYear": 2012,
    "endYear": 0,
    "version": "2.0",
    "original_term": "sushi"
}